import { EJExitSlotBonusState } from "states/slotbonus/ej-exit-slot-bonus-state";
import { BlastworksClientEvent } from "../ClientController";

export class SocialExitSlotBonusState extends EJExitSlotBonusState {
    public complete() {
        this.stateMachine.dispatchClientEvent(BlastworksClientEvent.BONUS_COMPLETE);
        super.complete();
    }
}